export default __webpack_public_path__ + "static/media/avto.3a0b21d5.webp";